import { createStore } from "vuex";
import { auth } from "./auth.module";
import { keepSignedIn } from "./keepSignIn.module";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
  plugins: [createPersistedState()],
  state: {
    isLogin: false,
    user: null,
    panel: null,
    panelData: {},
    dnsActivationData: null,
     notify: false,
    loading: false,
    message: '',
    errors: null,
  },
  getters: {
    getLoginStatus: (state) => {
      return state.isLogin;
    },
    getUser: (state) => {
      return state.user;
    },
    getPanel: (state) => {
      return state.panel;
    },
    getPanelData: (state) => {
      return state.panelData;
    },
    getServerWSData: (state) => {
      return state.serverWSData;
    },
    getDnsActivationData: (state) => {
  return state.dnsActivationData;
},
getNotify: (state) => state.notify,
    getLoading: (state) => state.loading,
    getMessage: (state) => state.message,
    getErrors: (state) => state.errors,

  },
  mutations: {
  setDnsActivationData(state, data) {
    state.dnsActivationData = data;
  },
    channgeIsLoginState(state, payload) {
      state.isLogin = payload;
    },
    channgeUserState(state, payload) {
      state.user = payload;
    },
    changePanel(state, payload) {
      state.panel = payload;
    },
    changePanelData(state, payload) {
      state.panelData = payload;
    },
    setNotify(state, payload) {
      state.notify = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setMessage(state, payload) {
      state.message = payload;
    },
    setErrors(state, payload) {
      state.errors = payload;
    },
   
  },
  actions: {
    changLoginStatus(context, payload) {
      context.commit("channgeIsLoginState", payload);
    },
    setUser(context, payload) {
      context.commit("channgeUserState", payload);
    },
    setPanel(context, payload) {
      context.commit("changePanel", payload);
    },
    setPanelData(context, payload) {
      context.commit("changePanelData", payload);
    },
    setNotify(context, payload) {
      context.commit("setNotify", payload);
    },
    setLoading(context, payload) {
      context.commit("setLoading", payload);
    },
    setMessage(context, payload) {
      context.commit("setMessage", payload);
    },
    setErrors(context, payload) {
      context.commit("setErrors", payload);
    },
  },
  modules: {
    auth,
    keepSignedIn,
  },
});

export default store;
